import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AuthModule} from "./auth/auth.module";
import {GoogleLoginProvider, SOCIAL_AUTH_CONFIG, SocialAuthServiceConfig, SocialLoginModule} from "@abacritt/angularx-social-login";
import {ConfigService} from "./core/config/config.service";
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { environment } from '../environments/environment';

// Load config
export function initializeApp(configService: ConfigService) {
  return () => configService.load();
}

export function socialConfigFactory(configService: ConfigService) {
  let providers = [];

  providers.push({
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(configService.GSuiteClientID),
  });

  const disableAutoLogin = (environment as { disableGoogleAutoLogin?: boolean }).disableGoogleAutoLogin === true;
  return {
    autoLogin: !disableAutoLogin,
    providers: providers,
  } as SocialAuthServiceConfig;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AuthModule,
    SocialLoginModule,
  ],

  bootstrap: [AppComponent],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: SOCIAL_AUTH_CONFIG,
      useFactory: socialConfigFactory,
      deps: [ConfigService],
    },
    providePrimeNG({
      theme: {
        preset: Aura
      }
    })
  ]
})
export class AppModule { }
